// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1T4nL","right":"Footer_right__3Q2mt","buttons":"Footer_buttons__eKh2Z"};